var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.881 13.3333H21.7381C21.909 13.3333 22.0476 13.2027 22.0476 13.0417V11.2917C22.0476 11.1307 21.909 11 21.7381 11H19.881C18.004 11 16.4762 12.4391 16.4762 14.2083V16.25H14.3095C14.1387 16.25 14 16.3807 14 16.5417V18.2917C14 18.4527 14.1387 18.5833 14.3095 18.5833H16.4762V24.7083C16.4762 24.8693 16.6149 25 16.7857 25H18.6429C18.8137 25 18.9524 24.8693 18.9524 24.7083V18.5833H21.119C21.2521 18.5833 21.3704 18.5028 21.4131 18.3838L22.0321 16.6338C22.0637 16.5452 22.0476 16.4472 21.9894 16.3707C21.9306 16.2949 21.8378 16.25 21.7381 16.25H18.9524V14.2083C18.9524 13.7259 19.369 13.3333 19.881 13.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookWhiteIcon);
export default __webpack_public_path__ + "static/media/facebook_white_icon.765ba14d.svg";
export { ForwardRef as ReactComponent };